var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t('login.loginError')))]),_c('v-btn',{on:{"click":_vm.login}},[_vm._v(" "+_vm._s(_vm.$t('welcome.button.loginOrRegister'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }